export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5359.be2b6549.jpg";